export const CLASS_NAME = 'cst-page-insights'
export const PATH = '/analytics'
